import icons from "../../../../../Data/icons";
import classes from "./addNationality.module.css";


const AddNationality = ({
  setNationalityName,
  setActive, 
  active,
  setImageFile,
  nationalityName,
  imageFile,
  fileRef
  
}) => {
  const DollarSign = icons.Dollar;
  const ImagIcon = icons.image
  const NameIcon= icons.name
  const handleNameChange = (e) => {
    setNationalityName(e.target.value);
  };
  const handleActiveChange = (e) => {
    const  isChecked =e.target.checked
    setActive(isChecked ? 1 :0);
  };
  const handleImageChange = (e)=>{

    const file = e.target.files[0]
  setImageFile(file)
  
  }

  return (
    <div className={classes.formCard} >
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">الاسم </label>
          <div className={classes.iconInput}>
            <NameIcon />
          </div>
          <input
            type="text"
        
            placeholder="ادخل الجنسية"
            value={nationalityName}
            onChange={handleNameChange}
          
            className={classes.inputCustom}
          />
        </div>
       
        
        <div className={classes.formCol}> 
           <label htmlFor="" className={active ? `${classes.active}` : `${classes.disActive}`}> {active==1 ?" نشط":"غير نشط"} </label>
         
          <label class="switch">
           <input type="checkbox"        onChange={handleActiveChange} checked={active} />
             <span class="slider round"></span>
         </label>   
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الصورة</label>
          <div className={classes.iconInput}>
            <ImagIcon />
          </div>

          <input type="file" ref={fileRef}  className={classes.inputCustom} onChange={handleImageChange} />
          <div>
   
    </div>
     
        </div>
     
      </div>
    </div>
  );
};

export default AddNationality;
